import { render, staticRenderFns } from "./formConfig.vue?vue&type=template&id=872edf7e&scoped=true&"
import script from "./formConfig.vue?vue&type=script&lang=js&"
export * from "./formConfig.vue?vue&type=script&lang=js&"
import style0 from "./formConfig.vue?vue&type=style&index=0&id=872edf7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872edf7e",
  null
  
)

export default component.exports